/**
 * Obtient la traduction du niveau utilisateur
 * @param {string[]} badges - Les badges de l'utilisateur
 * @param {Function} t - Fonction de traduction (i18next)
 * @returns {string} - Niveau traduit
 */
export const getLevelText = (badges, t) => {
  if (!badges || badges.length === 0) return t('levels.welcome');
  
  // Priorité aux badges connus
  const knownBadges = ['welcome', 'amateur', 'intermediate', 'expert', 'master'];
  
  for (const knownBadge of knownBadges) {
    if (badges.includes(knownBadge)) {
      return t(`levels.${knownBadge}`);
    }
  }
  
  // Si aucun badge connu n'est trouvé, utiliser le premier
  const badge = badges[0];
  return t(`levels.${badge}`) || badge;
};

/**
 * Obtient l'icône correspondant au niveau
 * @param {string[]} badges - Les badges de l'utilisateur
 * @returns {string} - Nom de l'icône
 */
export const getLevelIcon = (badges) => {
  if (!badges || badges.length === 0) return 'award';
  
  const badge = badges[0];
  
  // Mapper les badges aux icônes
  const iconMapping = {
    welcome: 'award',
    amateur: 'award',
    intermediate: 'award',
    expert: 'award', 
    master: 'award'
  };
  
  return iconMapping[badge] || 'award';
};
